import { render, staticRenderFns } from "./bulk-zuweisen-modal.vue?vue&type=template&id=791e11e3"
import script from "./bulk-zuweisen-modal.vue?vue&type=script&lang=js"
export * from "./bulk-zuweisen-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports